// ═══════════════════════════════════════════════════════════════
// AI POLICE — SPEECH UTILITIES v2
// Speech-to-Text (Web Speech API) + Text-to-Speech
// + Continuous Recording Mode for transcription
// ═══════════════════════════════════════════════════════════════

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

// Standard recognition (single utterance, for quick questions)
export function createRecognition(lang = 'nl') {
  if (!SpeechRecognition) return null;
  const recognition = new SpeechRecognition();
  recognition.continuous = false;
  recognition.interimResults = true;
  recognition.lang = lang === 'nl' ? 'nl-NL' : 'en-US';
  recognition.maxAlternatives = 1;
  return recognition;
}

// Continuous recognition (for recording mode — keeps listening)
export function createContinuousRecognition(lang = 'nl') {
  if (!SpeechRecognition) return null;
  const recognition = new SpeechRecognition();
  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.lang = lang === 'nl' ? 'nl-NL' : 'en-US';
  recognition.maxAlternatives = 1;
  return recognition;
}

export function isSTTSupported() {
  return !!SpeechRecognition;
}

export function isTTSSupported() {
  return 'speechSynthesis' in window;
}

export function speak(text, lang = 'nl', onEnd = null) {
  if (!isTTSSupported()) return;
  window.speechSynthesis.cancel();
  
  const clean = text
    .replace(/\*\*(.*?)\*\*/g, '$1')
    .replace(/\*(.*?)\*/g, '$1')
    .replace(/#{1,6}\s/g, '')
    .replace(/\[.*?\]\(.*?\)/g, '')
    .replace(/[|─━═]/g, '')
    .replace(/\n{2,}/g, '. ')
    .replace(/\n/g, ' ')
    .trim();

  const utterance = new SpeechSynthesisUtterance(clean);
  utterance.lang = lang === 'nl' ? 'nl-NL' : 'en-US';
  utterance.rate = 0.95;
  utterance.pitch = 1;
  
  if (onEnd) utterance.onend = onEnd;
  
  window.speechSynthesis.speak(utterance);
}

export function stopSpeaking() {
  if (isTTSSupported()) {
    window.speechSynthesis.cancel();
  }
}

export function generateTranscript(messages, moduleName, lang) {
  const now = new Date();
  const header = lang === 'nl'
    ? `AI POLICE — TRANSCRIPT\nModule: ${moduleName}\nDatum: ${now.toLocaleDateString('nl-NL')} ${now.toLocaleTimeString('nl-NL')}\nNoodgevallen: 112\n${'═'.repeat(60)}\n\n`
    : `AI POLICE — TRANSCRIPT\nModule: ${moduleName}\nDate: ${now.toLocaleDateString('en-GB')} ${now.toLocaleTimeString('en-GB')}\nEmergencies: 112\n${'═'.repeat(60)}\n\n`;

  const body = messages.map(m => {
    const time = new Date(m.timestamp).toLocaleTimeString(lang === 'nl' ? 'nl-NL' : 'en-GB');
    const sender = m.role === 'user'
      ? (lang === 'nl' ? 'GEBRUIKER' : 'USER')
      : 'AI POLICE';
    const text = m.content
      .replace(/\*\*(.*?)\*\*/g, '$1')
      .replace(/\*(.*?)\*/g, '$1');
    return `[${time}] ${sender}:\n${text}\n`;
  }).join('\n');

  return header + body;
}

export function downloadTranscript(messages, moduleName, lang) {
  const text = generateTranscript(messages, moduleName, lang);
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `ai-police-transcript-${Date.now()}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
